// entries/zh-Hans-CN.ts
import antdZh from "antd/lib/locale/zh_CN"
import zhMessages from "../locales/zh-Hans.json"

const ZhLang = {
  messages: {
    ...zhMessages
  },
  antd: antdZh,
  locale: "zh-Hans-CN"
}

export default ZhLang
